import {ModuleRegistry, ReactLazyComponent} from 'react-module-container';

export default class CashierPayAppLazy extends (ReactLazyComponent as React.ComponentClass<{manifest}>) {
  constructor(props) {
    super(props, props.manifest);
  }
}



// WEBPACK FOOTER //
// ./CashierPayAppLazy/CashierPayAppLazy.ts